import React from 'react';
import './GameTags.scss'
import { roundDownToNearest } from '../../../services/CalendarServices';


const getTag = (tagName: string, additional: any = {}, tagClass: string = '') => {
    let content = null


    interface Dictionary {
        [key: string]: string; // Разрешаем любые строковые ключи
    }

    const tagNameContents: Dictionary = {
        "registration_opened": "Открыто",
        "registration_closed": "Закрыто",
        "announced": "Анонсировано",
        "in_progress": "В разгаре",
        "completed": "Завершено",
        "cancelled": "Отменено",
        "big": 'Большая',
        "roleplay": "Ролевая",
        "Epic": "Эпическая"
    }

    const tagContent = tagNameContents[tagName];

    if (additional.peopleCount) {
        content = <>
            <img alt='' src='/calendar/peopleCountIcon.svg' className='gameTags_tag-icon'></img>
            {roundDownToNearest(additional.peopleCount)}+
        </>
    }
    else if (tagContent) {
        content = tagContent;
    } else {
        content = tagName
        tagName = 'other'
    }

    return <div key={additional.key} className={`gameTags_tag gameTags_tag-${tagName} ${tagClass || ''}`}>{content}</div>
}

export type peopleCount = string | number;

interface GameTagsProps {
    className?: string;
    openState: string;
    peopleCount: peopleCount; // вот такой же тип используется еще в gameCard, по хорошему бы вынести этот union в отдельный тип и его использовать
    additionalTags: Array<string>;
    tagClass?: string;
}

function GameTags(props: GameTagsProps) {

    const { openState, peopleCount, additionalTags, className } = props

    const isOpenedTag = getTag(openState, [], props.tagClass)

    const peopleCountTag = getTag('peopleCount', { peopleCount: peopleCount }, props.tagClass);

    const otherTags = additionalTags.map((tag, index) => {
        const tagEl = getTag(tag, { key: index }, props.tagClass);
        return tagEl;
    })

    return (
        <div className={"gameTags" + (className || '')}>
            {isOpenedTag}
            {otherTags}
            {peopleCountTag}
        </div>
    )
}

export default GameTags;
